import { render } from "./WCTextArea.vue?vue&type=template&id=7c25d935"
import script from "./WCTextArea.vue?vue&type=script&lang=js"
export * from "./WCTextArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__